export default () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="100%"
      height="55"
      fill="none"
      viewBox="0 0 321 55"
    >
      <path
        fill="#E0E0E0"
        fillRule="evenodd"
        d="M82 0h156.36v55H82V0Z"
        clipRule="evenodd"
      ></path>
      <path
        fill="#D3D3D3"
        stroke="#BDBDBD"
        strokeDasharray="2 2"
        strokeLinejoin="round"
        d="M221 13H100v29h121V13Z"
      ></path>
      <path
        fill="#E0E0E0"
        d="M320.36 0H246v55h74.36V0Z"
      ></path>
      <path
        fill="#D3D3D3"
        stroke="#BDBDBD"
        strokeDasharray="2 2"
        strokeLinejoin="round"
        d="M303 13h-39v29h39V13Z"
      ></path>
      <path
        fill="#E0E0E0"
        d="M74.36 0H0v55h74.36V0Z"
      ></path>
      <path
        fill="#D3D3D3"
        stroke="#BDBDBD"
        strokeDasharray="2 2"
        strokeLinejoin="round"
        d="M57 13H18v29h39V13Z"
      ></path>
    </svg>
  );
};
